import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import Button from "../Button/Button";
import {
  StyledModal,
  StyledModalContent,
  ModalTitle,
  StyledNewSelect,
} from "./LanguageModal.styled";
import { changeLanguageOptions } from "../../reducers/languageOptionsSlice";

const LanguageModal = ({ handleModal, isMobile, handleSaveLanguage }) => {
  const { value, options } = useSelector((state) => state.languageOptions);

  const {
    language_selector: {
      page_content: {
        languages_label,
        languages_text,
        save_button,
        cancel_button,
        header,
      },
    },
  } = useSelector((state) => state.headerAndFooter);

  const dispatch = useDispatch();
  const [selectedCountry, setSelectedCountry] = React.useState(value);

  const defaultOptions = options.map((option) => {
    return { value: option.language_code, title: option.language };
  });

  const modalOptions = [...defaultOptions];

  return (
    <StyledModal showXButton={false} onClose={handleModal} isMobile={isMobile}>
      <StyledModalContent>
        <ModalTitle>{header}</ModalTitle>
        <StyledNewSelect
          data-cy="language-select"
          label={languages_label}
          message={languages_text}
          isMobile={isMobile}
          onChange={(event) => setSelectedCountry(event.target.value)}
          value={selectedCountry}
        >
          {modalOptions.map((option) => {
            return (
              <StyledNewSelect.Option key={option.value} value={option.value}>
                {option.title}
              </StyledNewSelect.Option>
            );
          })}
        </StyledNewSelect>
      </StyledModalContent>
      <Button
        noLink
        isMobile={isMobile}
        nextButtonDisabled={false}
        hideNextButtonIcon
        continueButtonText={save_button.label}
        backButtonText={cancel_button.label}
        onNextClick={() => {
          dispatch(changeLanguageOptions(selectedCountry));
          handleSaveLanguage();
        }}
        onBackClick={handleModal}
      />
    </StyledModal>
  );
};

LanguageModal.propTypes = {
  handleModal: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  handleSaveLanguage: PropTypes.func.isRequired,
};

export default LanguageModal;
